
//******************Exchange Rate Server Calls******************;

import {ChangePasswordActions} from './ChangePasswordConstants';
import store from '../../../Store/store'
import {ROOT_URL,getCookie} from '../../../Config/Config';
import {failure_messages} from "Messages"


export const ChangePasswordServer = {
  //  getChangePassword:getChangePassword,
  ChangePassword:ChangePassword,
};

//******************Insert ChangePasswords******************;

function ChangePassword(data){
      // alert(JSON.stringify(data))
      const request=fetch(ROOT_URL+'/api/applicationUser/updateNJTUserPassword', {
          method: 'Post',
          mode: 'cors',
          headers: { 
            'authorization':getCookie("admin_token_partner"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
          }).then((response)=>{
           response.json().then(response=>{
             if(response.status == "200"){
             // alert(JSON.stringify(response))
            store.dispatch({type:ChangePasswordActions.ChangePassword_POST.SUCCESS,payload:data, message:response.message});
            return ;
            }else
            {
              store.dispatch({type:ChangePasswordActions.ChangePassword_POST.FAILED, error:response.error});
              return ;
              }    
           });
          }).catch((error) => {
          //  alert(error)
           store.dispatch({type:ChangePasswordActions.ChangePassword_POST.FAILED, error:failure_messages.unExpectedError});
            })
      return {type:ChangePasswordActions.ChangePassword_POST.LOADING}

};
  

//******************Get ChangePasswords******************;


//******************Update ChangePassword******************;

  
// function getChangePassword(){
//       const request=fetch(ROOT_URL+'/api/exchangeRate/getExchangeRate/', {
//           method: 'GET',
//           mode: 'cors',
//           headers: {'Content-Type':'application/json'},
//          // body: JSON.stringify(data)
//           }).then((response)=>{
//             response.json().then(response=>{
//               if(response.status == "200"){
//                 console.log(response)
//                 if(response.ChangePassword.length>0)
//              store.dispatch({type:ChangePasswordActions.ChangePassword_POST.SUCCESS,payload:response.ChangePassword});
//              else
//              store.dispatch({type:ChangePasswordActions.ChangePassword_POST.NEW});
             
//              return ;
//              }else
//              {
//                store.dispatch({type:ChangePasswordActions.ChangePassword_POST.FAILED});
//                return ;
//                }    
//             });
//            }).catch((error) => {
//             store.dispatch({type:ChangePasswordActions.ChangePassword_POST.FAILED});
//           })
//        return {type:ChangePasswordActions.ChangePassword_POST.LOADING}
 
//     };
  
// function updateChangePassword(data){
//   const request=fetch(ROOT_URL+'/api/exchangeRate/BulkUpdateExchangeRate', {
//     method: 'Post',
//     mode: 'cors',
//     headers: {'Content-Type':'application/json'},
//     body: JSON.stringify(data)
//     }).then((response)=>{
//      response.json().then(response=>{
//        if(response.status == "200"){
//          console.log(response)
//       store.dispatch({type:ChangePasswordActions.ChangePassword_POST.SUCCESS});
//       return ;
//       }else
//       {
//         store.dispatch({type:ChangePasswordActions.ChangePassword_POST.FAILED});
//         return ;
//         }    
//      });
//     }).catch((error) => {
//       store.dispatch({type:ChangePasswordActions.ChangePassword_POST.FAILED});
//     })
// return {type:ChangePasswordActions.ChangePassword_POST.LOADING}

// };
